export const USER_SEARCH_FILTER_TYPE = "queryFilter";
export const REFERENCED_USER_SEARCH_FILTER_TYPE = "referenced";
export const INLINE_SEARCH_FILTER_TYPE = "inlineQueryString";
export const FILTER_SCOPES = { MY_FILTERS: "OWNED", ALL: "ALL" };
export const FILTER_USAGE_ENTITY_TYPE = {
  SAVED_SEARCHES: "SEARCHES",
  DASHBOARD_WIDGET: "DASHBOARD_WIDGET",
  EVENT_DEFINITION: "EVENT_DEFINITION",
  SIGMA_RULE: "SIGMA_RULE"
};
